import React from 'react';
import TreeNode, { TreeNodeProps } from './TreeNode';

interface TreeStructureProps {
  data: any[];
  onFolderToggle: (node: TreeNodeProps['node']) => void;
  selectedFile: { refrenceId: string };
}

const TreeStructure: React.FC<TreeStructureProps> = ({
  data = [],
  onFolderToggle,
  selectedFile,
}) => {
  const [nodes, setNodes] = React.useState<TreeNodeProps['node'][]>(data);

  React.useEffect(() => {
    setNodes(data);
    //console.log('*** data', data);
  }, [data]);

  return (
    <ul className="file-tree">
      {nodes.map((item: any, index: number) => (
        <TreeNode
          key={index}
          node={item}
          onFolderToggle={onFolderToggle}
          selectedFile={selectedFile}
        />
      ))}
    </ul>
  );
};

export default TreeStructure;
